import React from 'react';
import Icon from '../../../../basic/icons';
import Box from '../../../../basic/box';
import { ISocialLinks } from '../../IFooter';

const SocialIcon = ({ icon }: ISocialLinks) => {
  return (
    <Box shape="circle" className="p-xs bg-white cursor-pointer">
      <Icon name={icon} className="text-2xl text-black" role='img' aria-label={icon}/>
    </Box>
  );
};

export default SocialIcon;
